import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useMemo } from 'react';
import { Select, Space, TimePicker } from 'udesk-ui';
import moment from 'moment';

const commonStyle = { width: 150 };
const format = 'HH:mm';

interface TemplateProps {
    value?: {
        frequency?: number;
        week?: number;
        day?: number;
        time?: string;
    };
    onChange?: (v: TemplateProps['value']) => void;
    onFrequencyChange?: () => void;
    hideFrequencyeList?: number[];
    allowFrequencyClear?: boolean;
}

const Template: FC<TemplateProps> = memo((props) => {
    const {
        value,
        onChange,
        onFrequencyChange: _onFrequencyChange,
        hideFrequencyeList,
        allowFrequencyClear,
    } = props;

    const onFrequencyChange = (v) => {
        onChange?.({
            ...value,
            frequency: v,
            day: undefined,
            time: undefined,
            week: undefined,
        });
        _onFrequencyChange?.();
    };

    const onDayOfWeekChange = (v) => {
        onChange?.({
            ...value,
            week: v,
        });
    };

    const onDayOfMonthChange = (v) => {
        onChange?.({
            ...value,
            day: v,
        });
    };

    const days = useMemo(() => {
        const days: number[] = [];

        for (let i = 1; i <= 30; i++) {
            days.push(i);
        }

        return days;
    }, []);

    const onTimeChange = (v) => {
        onChange?.({
            ...value,
            time: v,
        });
    };

    return (
        <Space>
            <Select
                style={commonStyle}
                value={value?.frequency}
                onChange={onFrequencyChange}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                allowClear={allowFrequencyClear}
                placeholder={/* 请选择 */UdeskLocales['current'].components.frequency.index.pleaseSelect}
            >
                {Udesk.enums.assessFrequencyTypes
                    .filter((item) => !hideFrequencyeList?.includes(item.id))
                    .map((item) => (
                        <Select.Option value={item.id}>{item.name}</Select.Option>
                    ))}
            </Select>

            {value?.frequency === Udesk.enums.assessFrequencyTypes.everyWeek.id ? (
                <Select
                    style={commonStyle}
                    // mode="multiple"
                    value={value?.week}
                    onChange={onDayOfWeekChange}
                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                    placeholder={/* 请选择 */UdeskLocales['current'].components.frequency.index.pleaseSelect}
                >
                    {Udesk.enums.assessFrequencyWeekDays.map((item) => (
                        <Select.Option value={item.id}>{item.name}</Select.Option>
                    ))}
                </Select>
            ) : null}

            {value?.frequency === Udesk.enums.assessFrequencyTypes.everyMonth.id ? (
                <Select
                    style={commonStyle}
                    // mode="multiple"
                    value={value?.day}
                    onChange={onDayOfMonthChange}
                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                    placeholder={/* 请选择 */UdeskLocales['current'].components.frequency.index.pleaseSelect}
                >
                    {days.map((item) => (
                        <Select.Option value={item}>
                            {item + /* 号 */ UdeskLocales['current'].components.frequency.index.no}
                        </Select.Option>
                    ))}
                </Select>
            ) : null}

            <TimePicker
                style={commonStyle}
                value={
                    value?.time === undefined || value?.time === null
                        ? value?.time
                        : moment(value?.time, format)
                }
                format={format}
                allowClear={false}
                onChange={(v) => onTimeChange(v?.format(format))}
            />
        </Space>
    );
});

export default Template;

export const checkRequird = (v: TemplateProps['value']) => {
    if (!v) return false;

    if (v.frequency === Udesk.enums.assessFrequencyTypes.everyDay.id) {
        if (!v.time) return false;
    } else if (v.frequency === Udesk.enums.assessFrequencyTypes.everyWeek.id) {
        if (!v.week || !v.time) return false;
    } else if (v.frequency === Udesk.enums.assessFrequencyTypes.everyMonth.id) {
        if (!v.day || !v.time) return false;
    }

    return true;
};
